import { render, staticRenderFns } from "./StockReductionDetails_Total.vue?vue&type=template&id=378f598a&"
import script from "./StockReductionDetails_Total.vue?vue&type=script&lang=js&"
export * from "./StockReductionDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports